import { combineReducers } from 'redux';
import * as evt from './jigsaw-events';
import * as m from './jigsaw-methods';
import highlights from './userdata/highlights/reducer';
import bookmarks from './userdata/bookmarks/reducer';
import notes from './userdata/notes/reducer';
import interactionErrors from './error-collector';
import zoom from './zoom/reducer';
import pageLoading from './page-loading-reducer';
import devices from './devices-reducer';
import dps from './dps/reducer';
import pageLoad from 'app/api/redux-jigsaw/page-load-event-reducer';
import { createSimpleKeyValueReducer } from '../redux-util/general-helpers';
import { createBaseAsyncReducer } from '../redux-util/async-helpers';
import { withDestroyViewerReset } from '../reset-reducer-helpers';

const asyncViewerReset = [
  m.CREATE_PAGE_VIEWER,
  m.HAS_NEXT_PAGE,
  m.HAS_PREV_PAGE,
  m.GET_TOC,
  m.SEARCH_CONTENT,
  m.GET_THUMBNAILS,
  m.GET_CITATION,
  m.GET_PAGE_BREAKS,
  m.GET_ANCILLARIES,
];

const keyValViewerReset = [evt.BOOK_PAGE_BREAK];

function getReducers(keys, fn) {
  return keys
    .map(k => ({ [k]: fn(k) }))
    .reduce((acc, cv) => {
      return Object.assign(acc, cv);
    }, {});
}

export default combineReducers({
  ...getReducers(asyncViewerReset, k =>
    withDestroyViewerReset(createBaseAsyncReducer(k))
  ),
  ...getReducers(keyValViewerReset, k =>
    withDestroyViewerReset(createSimpleKeyValueReducer(k))
  ),
  [m.GET_BOOK_LIST]: createBaseAsyncReducer(m.GET_BOOK_LIST),
  [m.GET_USER_INFO]: createBaseAsyncReducer(m.GET_USER_INFO),
  [evt.PAGE_LOAD]: pageLoad,
  highlights,
  bookmarks,
  notes,
  interactionErrors,
  zoom,
  pageLoading,
  devices,
  dps,
});
